import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../CloudStaffDashboard.css';
import cloudsafeLogo from '../../../../assets/cloudsafe-logo.png';
import CloudStaffSidebar from '../CloudStaffSidebar';
import ToursManager from './ToursManager';
import {
  FaArrowLeft, FaUserCircle, FaSignOutAlt, FaBell, FaBars
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import { getUserRole } from '../../../../utils/roleUtils';
import { clearToken } from '../../../../utils/auth';
import { getApiEndpoint } from '../../../../config/api';

const ToursManagerPage = () => {
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [userName, setUserName] = useState('');
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  useEffect(() => {
    const userRole = getUserRole();
    if (userRole !== 'cloud_staff' && userRole !== 'super_admin') {
      toast.error('Access denied');
      navigate('/login');
      return;
    }
    loadProfile();
  }, [navigate]);

  const loadProfile = async () => {
    try {
      const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };
      const res = await fetch(getApiEndpoint('/api/users/profile'), { headers });
      if (res.ok) {
        const d = await res.json();
        setUserName(`${d.firstName || d.first_name || ''} ${d.lastName || d.last_name || ''}`);
      }
    } catch {}
  };

  const handleLogout = () => {
    clearToken();
    navigate('/login');
  };

  return (
    <div className="cs-dashboard">
      {/* Header */}
      <header className="cs-header">
        <div className="cs-header-left">
          <button className="cs-mobile-menu-btn" onClick={() => setMobileSidebarOpen(true)} aria-label="Open menu">
            <FaBars />
          </button>
          <Link to="/cloud-staff/dashboard" className="cs-logo-link">
            <img src={cloudsafeLogo} alt="CloudSafe" className="cs-logo" />
          </Link>
          <span className="cs-header-divider" />
          <span className="cs-header-title">Staff Tools</span>
        </div>
        <div className="cs-header-right">
          <button className="cs-icon-btn" title="Notifications" aria-label="Notifications">
            <FaBell />
          </button>
          <div className="cs-user-menu-container">
            <button className="cs-user-btn" onClick={() => setShowUserMenu(!showUserMenu)} aria-label="User menu">
              <FaUserCircle />
              <span className="cs-user-name">{userName}</span>
            </button>
            {showUserMenu && (
              <div className="cs-user-dropdown">
                <button onClick={handleLogout} className="cs-user-dropdown-item cs-logout">
                  <FaSignOutAlt /> Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      <div className="cs-layout">
        <CloudStaffSidebar
          active="tours"
          mobileOpen={mobileSidebarOpen}
          onClose={() => setMobileSidebarOpen(false)}
        />
        <main className="cs-content">
          <div className="cs-breadcrumb">
            <Link to="/cloud-staff/dashboard"><FaArrowLeft /> Dashboard</Link>
            <span>/</span>
            <span>3D Tour Add-on</span>
          </div>
          <ToursManager />
        </main>
      </div>
    </div>
  );
};

export default ToursManagerPage;
